module.exports = __webpack_public_path__ + "img/logo_tele2.60e49ba8.svg";